export const OOS_RECOVERY_OPTIONS = {
  STORE_PICKUP_OPTION: 'STORE_PICKUP_OPTION',
  STH_DELIVERY_OPTION: 'STH_DELIVERY_OPTION',
  BODFS_DELIVERY_OPTION: 'BODFS_DELIVERY_OPTION',
} as const;

export type TOosRecoveryOption = keyof typeof OOS_RECOVERY_OPTIONS;

export enum FLOW_TYPES {
  BOPIS_OOS_RECOVERY = 'BOPIS_OOS_RECOVERY',
  EDIT_PICKUP_LOCATION = 'EDIT_PICKUP_LOCATION',
  EDIT_DELIVERY_ADDRESS = 'EDIT_DELIVERY_ADDRESS',
}
